var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 76,
    viewBox: "0 0 61 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9091 0H11.0909C4.96318 0 0 4.85857 0 10.8571V65.1429C0 71.1414 4.96318 76 11.0909 76H49.9091C56.0368 76 61 71.1414 61 65.1429V10.8571C61 4.85857 56.0368 0 49.9091 0ZM43.5595 50.7843L29.6959 64.3557C28.6145 65.4143 26.8677 65.4143 25.7864 64.3557L17.4682 56.2129C16.47 55.0729 16.6086 53.3629 17.7732 52.3857C18.7991 51.5171 20.3518 51.5171 21.3777 52.3857L27.7273 58.6014L39.6223 46.9571C40.7868 45.98 42.5336 46.1157 43.5318 47.2557C44.4191 48.26 44.4191 49.78 43.5318 50.7843H43.5595ZM44.3636 40.7143H16.6364C15.1114 40.7143 13.8636 39.4929 13.8636 38C13.8636 36.5071 15.1114 35.2857 16.6364 35.2857H44.3636C45.8886 35.2857 47.1364 36.5071 47.1364 38C47.1364 39.4929 45.8886 40.7143 44.3636 40.7143ZM44.3636 29.8571H16.6364C15.1114 29.8571 13.8636 28.6357 13.8636 27.1429C13.8636 25.65 15.1114 24.4286 16.6364 24.4286H44.3636C45.8886 24.4286 47.1364 25.65 47.1364 27.1429C47.1364 28.6357 45.8886 29.8571 44.3636 29.8571ZM44.3636 19H16.6364C15.1114 19 13.8636 17.7786 13.8636 16.2857C13.8636 14.7929 15.1114 13.5714 16.6364 13.5714H44.3636C45.8886 13.5714 47.1364 14.7929 47.1364 16.2857C47.1364 17.7786 45.8886 19 44.3636 19Z",
    fill: "#00A100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.5b80911586806df4eaad2b63da9c8db7.svg";
export { ForwardRef as ReactComponent };